import hoistNonReactStatics from 'hoist-non-react-statics';
import React, { useContext } from 'react';

import { FormikContext as FormContext } from 'formik';

import { Dialog as DialogV2UI } from '@gogame/components';

import { Dialog } from './Dialog';
import { DialogCloseButton } from './DialogCloseButton';
import { DialogSubmitButton } from './DialogSubmitButton';

Dialog.SubmitButton = ({ children, label }) => {
  const { loadingCount, submitForm } = useContext(FormContext);

  const handleSubmit = async () => {
    await submitForm();
  };

  return (
    <DialogSubmitButton
      onSubmit={handleSubmit}
      disabled={loadingCount || loadingCount > 0}
      label={label}
    >
      {children}
    </DialogSubmitButton>
  );
};
Dialog.CloseButton = DialogCloseButton;

export default hoistNonReactStatics(Dialog, DialogV2UI, {
  CloseButton: true,
  SubmitButton: true,
});
